import type {VoicebotAction} from 'src/action-creators/voicebot-v2';
import type {VoicebotState} from 'src/types/voicebot-v2';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';

import {
  UPDATE_VOICEBOT_INFO,
  UPDATE_NODE_SCHEDULE,
  RESET,
  RESET_BOT_VARS,
} from 'src/action-creators/voicebot-v2';
import {transformPromptVariables} from 'src/utils/voicebot-v2';


export const initialState = {
  retell_bot_id: null,
  entity_type: null,
  retell_agent_id: null,
  retell_bot_name: null,
  retell_llm_id: null,
  retell_bot_description: null,
  max_concurrency_limit: '10',
  service_provider: 'retell',
  consent_type: 'implied',
  retry_1: {
    enabled: true,
    delay: {
      time_offset: {hours: 4, minutes: null, seconds: null},
      date_offset: {months: null, years: null, weeks: null, days: null},
    },
  },
  retry_2: {
    enabled: true,
    delay: {
      time_offset: {hours: null, minutes: null, seconds: null},
      date_offset: {months: null, years: null, weeks: null, days: 2},
    },
  },
  retry_3: {
    enabled: false,
    delay: {
      time_offset: {hours: null, minutes: null, seconds: null},
      date_offset: {months: null, years: null, weeks: null, days: null},
    },
  },
  from_number: null,
  to_number: null,
  recipient_name: null,

  // dynamic vars to map to retell vars
  prompt_variables: {
    /*
      "candidate/email": "{{$.entity_group_fetch__bh_candidate.response.relatedEntities.owner.entity.data.email3}}",
    */
  },
  whatsapp_template_id: null,
  whatsapp_template_user_mappings: null, // All `{{ }}` variables
  whatsapp_template_system_variables: null, // All `<>` variables
  communication_method: null,
  secondary_communication_method: null,
  email_sender_name: null,
  email_sender_address: null,
  email_receiver_address: null,
  email_subject: null,
  email_cc: null,
  email_bcc: null,
  email_template_system_variables: null,
  email_template_user_mappings: null,
  sms_body: null,
  content_subscription_category_id: null,
  ...getDefaultNodeScheduleState({blackout_action: 'SEND_BEFORE'}),
} as const;

export default (
  state: VoicebotState = initialState,
  action: VoicebotAction,
): VoicebotState => {
  switch (action.type) {
    case UPDATE_VOICEBOT_INFO:
      const updatePayload = action.payload;

      // Make sure vars are stored as object
      const {prompt_variables} = updatePayload || {};
      if (typeof prompt_variables === 'string') {
        updatePayload.prompt_variables =
          transformPromptVariables(prompt_variables);
      }

      return {
        ...state,
        ...updatePayload,
      };
    case UPDATE_NODE_SCHEDULE:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_BOT_VARS:
      return {
        ...state,
        retell_bot_id: null,
        retell_agent_id: null,
        retell_bot_name: null,
        retell_llm_id: null,
        retell_bot_description: null,
        prompt_variables: {},
      };
    case RESET:
      return {...initialState};
  }
  return state;
};
